import { gql } from '@/__generated__';

/**
 * AMARU-851 — opciones del multi-select de colecciones del tab General: ICN y CUSTOM de la
 * organización que esté seleccionada en el formulario (no necesariamente la organización
 * original del device — el usuario puede estar cambiándola en el mismo submit).
 *
 * Control dedicado, no comparte infraestructura con `StandardAutocompleteIds`/`icnCollections`
 * (que es global a la app y solo ICN) — evaluar en AMARU-852 si conviene fusionarlos.
 */
const GET_OWN_ORGANIZATION_COLLECTIONS = gql(`#graphql
  query DeviceConfiguration_GetOwnOrganizationCollections($organizationId: Int!) {
    collections(filter: { organizationId: $organizationId, types: [ICN, CUSTOM] }) {
      id
      name
      type
    }
  }
`);

export default GET_OWN_ORGANIZATION_COLLECTIONS;
